import { useMemo } from 'react'

import { useQueryGetAllProductsAvailability } from '@flecto/core/store'
import { type CoreProduct } from '@flecto/types'

import { useStoreBasket } from './useStoreBasket'
import { useStoreDates } from './useStoreDates'
import { useStoreDetails } from './useStoreDetails'
import { useStoreProductAvailabilityMerge } from './useStoreProductAvailabilityMerge'

export type UseStoreProductAvailabilityListOptions = {
  products?: CoreProduct[]
}

export function useStoreProductAvailabilityList({
  products,
}: UseStoreProductAvailabilityListOptions) {
  const store = useStoreDetails()
  const { startAt, endAt } = useStoreDates()
  const { products: basketProducts } = useStoreBasket()

  const productsToFilter = useMemo(() => {
    return products?.map((p) => {
      return {
        id: Number(p.id),
        quantity: 1,
      }
    })
  }, [products])

  const {
    data: productsAvailability,
    isFetching,
    refetch,
  } = useQueryGetAllProductsAvailability({
    storeDomain: store?.domain,
    options: {
      start_at: startAt ?? '',
      end_at: endAt ?? '',
      products: productsToFilter,
      enabled: Boolean(
        startAt && endAt && productsToFilter && productsToFilter.length > 0
      ),
    },
  })

  const productsWithAvailability = useMemo(
    () =>
      products?.map((product) => {
        const productAvailability =
          productsAvailability?.product_availability?.find(
            (ia) => ia.product.id === product.id
          )

        return useStoreProductAvailabilityMerge({
          product,
          productAvailability,
          quantityToAdd: 1,
          startAt,
          endAt,
        })
      }),
    [products, productsAvailability, basketProducts]
  )
  return {
    data: productsWithAvailability,
    isLoading: isFetching,
    refetchAvailability: refetch,
  }
}
